import { ClientType, PeerIdType, PeerMessage, PeerMessageType, PresenceMessageType, websocket } from '@playcastdotio/Messaging';
import { getStateStore } from '../../../stores';
import { sendMessage, storePeerData } from '..';
import { hostHandlePeerMessage } from '../../peers/host';
import { USE_SESSION_COORDINATOR, USE_MEDIA_COORDINATOR } from '../../../../config/featureFlags';
import { realtimeSignalingService } from '../../../../coordinators/init';

export const handlePeerMessage = (message: PeerMessage) => {
  console.log('Peer message:', message);
  switch (message.type) {
    case PeerMessageType.PEER_GET_ID_ANSWER: {
      console.log('Peer get id answer:', message);
      console.log('Peer get id answer with token?', !!message.peerToken);

      const target = message.peerIdType;
      const state = getStateStore('ipc');
      const hostPresence = state.hostPresenceState.currentState;

      // Store peer ID and token for reconnection
      if (message.peerToken) {
        console.log('Storing token for peer:', message.peerId, message.peerToken.substring(0, 5) + '...');
        storePeerData(message.peerIdType, message.peerId, message.peerToken);
      } else {
        console.warn('No token received for peer ID:', message.peerId);
      }

      if (message.iceServers) {
        console.log('Storing ice servers for peer:', message.peerId, message.iceServers);
        state.iceServerState.updateState({
          ...state.iceServerState.currentState,
          hostIceServers: message.iceServers,
        });
      }

      // STRANGLER-FIG: Route to PeerCoordinator via signaling service
      // PeerCoordinator subscribes to onPeerIdAssigned and handles
      // peer ID + ICE config internally.
      if (USE_MEDIA_COORDINATOR) {
        realtimeSignalingService.handleIncomingMessage(message);
      }

      switch (target) {
        case PeerIdType.HOST: {
          console.log('Host peer id:', message.peerId);
          hostPresence.hostPeerId = message.peerId;
          break;
        }
        case PeerIdType.REMOTE_HOST: {
          console.log('Remote host peer id:', message.peerId);
          hostPresence.remoteHostPeerId = message.peerId;
          break;
        }
        case PeerIdType.PLAYER:
        case PeerIdType.REMOTE_CLIENT: {
          console.log('Got peer id for player or remote client???', message);
          break;
        }
        default: {
          console.log('Unknown peer id target:', message);
          break;
        }
      }
      console.log('Updated host presence:', hostPresence);
      // update state
      state.hostPresenceState.updateState({ ...hostPresence });

      // STRANGLER-FIG: Skip PRESENCE_UPDATE when SessionCoordinator is active
      if (!USE_SESSION_COORDINATOR) {
        sendMessage(
          websocket.generators.presence(PresenceMessageType.PRESENCE_UPDATE, {
            clientType: ClientType.HOST,
            presence: hostPresence,
          }),
        );
      }

      break;
    }
    case PeerMessageType.PEER_SDP_ANSWER:
    case PeerMessageType.PEER_SDP_OFFER:
    case PeerMessageType.PEER_ICE_CANDIDATE: {
      if (USE_MEDIA_COORDINATOR) {
        realtimeSignalingService.handleIncomingMessage(message);
      } else {
        hostHandlePeerMessage(message);
      }
      break;
    }
    case PeerMessageType.PEER_ERROR:
    case PeerMessageType.PEER_GET_ID:
    case PeerMessageType.PEER_ICE_COMPLETE:
    case PeerMessageType.PEER_STATS:
    case PeerMessageType.PEER_STATS_SUCCESS: {
      // Unwanted messages
      console.log('Unwanted peer message:', message);
      break;
    }
  }
};
